module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vendo11-2c6e203a23c62a8f20d70f888e6eb91b.jpg";